import clsx from 'clsx';
import { Color } from '../../lib/types.ts';
import { UilDownloadAlt, UilEye } from '@iconscout/react-unicons';
import { cn } from '../../lib/helpers.ts';

const barVariants: Record<Color, string> = {
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    orange: 'bg-orange-500',
    red: 'bg-red-500',
    turquoise: 'bg-turquoise-500',
    purple: 'bg-purple-500',
    rose: 'bg-rose-500',
};

type WorksheetCardProps = {
    title: string;
    description: string;
    badge: string;
    color: Color;
    openHref: string;
    onDownload?: () => void;
    disabled?: boolean;
};

export function WorksheetCard({
    title,
    description,
    badge,
    color,
    openHref,
    onDownload,
    disabled = false,
}: WorksheetCardProps) {
    const bar = barVariants[color];

    return (
        <div
            role="link"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled}
            onClick={(e) => {
                if (disabled) return;
                if (e.defaultPrevented) return;
                window.open(openHref, '_blank');
            }}
            onKeyDown={(e) => {
                if (disabled) return;
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                window.open(openHref, '_blank', 'noopener,noreferrer');
            }}
            className={cn(
                'relative rounded-3xl bg-white shadow-sm transition-shadow',
                'cursor-pointer',
                !disabled && 'hover:shadow-md',
                disabled && 'cursor-not-allowed opacity-60'
            )}
        >
            <div
                className={clsx(
                    'absolute right-0 top-0 rounded-bl-2xl rounded-tr-2xl px-4 py-1 text-sm font-medium text-white',
                    bar
                )}
            >
                {badge}
            </div>

            <div
                className={clsx(
                    'absolute left-0 top-[15%] h-[70%] w-1 flex-shrink-0 rounded-r-md',
                    bar
                )}
            />

            <div className="grid grid-cols-[1fr_auto] items-center gap-6 p-6">
                <div className="min-w-0">
                    <div className="mb-1 text-base font-medium text-ink-900">
                        {title}
                    </div>
                    <p className="min-h-12 line-clamp-2 leading-6 font-normal text-ink-800">
                        {description}
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    {/* <button
                        type="button"
                        className={cn(
                            'flex h-11 w-11 items-center justify-center rounded-xl bg-cloud-200 text-ink-900 transition-colors',
                            'hover:bg-cloud-300',
                            disabled && 'pointer-events-none'
                        )}
                        aria-label="Otevřít PDF"
                        title="Otevřít PDF"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (disabled) return;
                            window.open(openHref, '_blank', 'noopener,noreferrer');
                        }}
                    >
                        <UilEye size={20} />
                    </button> */}

                    <button
                        type="button"
                        className={cn(
                            'flex h-11 w-11 items-center justify-center rounded-xl bg-cloud-200 text-ink-900 transition-colors',
                            'hover:bg-cloud-300',
                            disabled && 'pointer-events-none'
                        )}
                        aria-label="Stáhnout"
                        title="Stáhnout"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (disabled) return;
                            onDownload?.();
                        }}
                    >
                        <UilDownloadAlt size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
}

